import { render, staticRenderFns } from "./ipFilter.vue?vue&type=template&id=37489f02&scoped=true&"
import script from "./ipFilter.vue?vue&type=script&lang=js&"
export * from "./ipFilter.vue?vue&type=script&lang=js&"
import style0 from "./ipFilter.vue?vue&type=style&index=0&id=37489f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37489f02",
  null
  
)

export default component.exports